/*
 * Copyright (c) Nexign, JSC, 2021-2023.
 */
/**
 *
 * @author Vladislav Oshkanov
 * @author Yakov Gushchin
 * @author Ilya Baranchikov
 * @version 1.26.0
 * @since 1.14.0
 */

import { memo } from 'react';

import { RadioButtonContainerStyled } from './styled/RadioButtonStyled';

/**
 * @property {boolean} checked
 * @property {boolean} disabled(optional) - state of checkbox
 * @property {string} kind - type of checkbox
 * @property {string} label(optional) - label for checkbox
 * @property {Function} onChange - executable callback
 */
export interface IRadioButtonProps {
    checked: boolean;
    className?: string;
    dataName?: string;
    disabled?: boolean;
    kind: string;
    label?: string;
    name?: string;
    type?: 'checkbox' | 'radio';
    onChange: (event: boolean) => void;
}
/**
 * @description Component Checkbox
 * @interface IRadioButtonProps
 */
const RadioButton = ({
    disabled,
    checked,
    dataName,
    kind,
    name,
    type = 'checkbox',
    onChange,
    label,
    className,
}: IRadioButtonProps) => {
    return (
        <RadioButtonContainerStyled
            className={`checkbox ${className ? className : ''}`}
            data-name={dataName}
            kind={kind}
            onClick={() => (disabled ? '' : onChange(!checked))}
        >
            <input readOnly checked={checked} className="checkbox__input" disabled={disabled} name={name} type={type} />
            <label className="checkbox__label">{label}</label>
        </RadioButtonContainerStyled>
    );
};

RadioButton.defaultProps = {
    checked: false,
    label: '',
    kind: 'normal',
    disabled: false,
    onChange: () => {
        /** */
    },
};

export default memo(RadioButton);
